<template>
  <div>
    <Layout/>
    <h4>Especialidad</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idEspecialidad" class="form-label">IdEspecialidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoEspecialidad.idEspecialidad" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoEspecialidad.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoEspecialidad.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarEspecialidad" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEspecialidad" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditEspecialidad" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdMedico</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdEspecialidad</th>
          <th scope="col">Documento</th>
          <th scope="col">Estado</th>
          <th scope="col">PersonaFechaReg</th>
          <th scope="col">EspecialidadNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="medico in datosPaginados" :key="medico.idMedico">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(medico.idMedico)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(medico.idMedico)" title="Editar">edit_square</i></td>
          <td>{{medico.idMedico}}</td>
          <td>{{medico.idPersona}}</td>
          <td>{{medico.idEspecialidad}}</td>
          <td>{{medico.documento}}</td>
          <td>{{medico.estado}}</td>
          <td>{{getFormattedDate(medico.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{medico.especialidadNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteEspecialidad(medico.idMedico)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idMedico" class="form-label">IdMedico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedico" name="idMedico" v-model="datoMedico.idMedico" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idPersona" name="idPersona" v-model="datoMedico.idPersona"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="persona" name="persona" v-model="datoMedico.persona" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalPersonaLOV"
                      title="Buscar Personas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEspecialidad" class="form-label">IdEspecialidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoMedico.idEspecialidad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoMedico.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedico" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedico" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Medico -->
    <MedicoLOVdet @DatosMedico="GetDataMedicoLOVdet($event)"/>
<!-- Lista de Valores: Persona -->
    <PersonaLOVdet @DatosPersona="GetDataPersonaLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import MedicoLOVdet from '../../components/lovs/MedicoLOV.vue'
import PersonaLOVdet from '../../components/lovs/PersonaLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, MedicoLOVdet
, PersonaLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      especialidads : [],
      datoEspecialidad : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idEspecialidad: '',
// Variables master
// Variables details
      medicos : [],
      datoMedico : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idEspecialidad = this.$route.params.p_idespecialidad
    this.abrirEditar(this.p_idEspecialidad)
    this.getMedicos()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoEspecialidad.idEspecialidad === ''){
        swal("Error!", "El elemento idEspecialidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEspecialidad.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEspecialidad.tipo === ''){
        swal("Error!", "El elemento tipo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEspecialidad.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarEspecialidad(){
      if(this.validarForm() === 1){
        try {
          await api.post('/especialidads', this.datoEspecialidad)
          swal("Correcto!", "Especialidad creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditEspecialidad(){
      if(this.validarForm() === 1){
        try {
          await api.post('/especialidads', this.datoEspecialidad)
          swal("Correcto!", "Especialidad creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoEspecialidad={}
      this.titulo   = 'Crear Especialidad'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idEspecialidad){
      this.modalWindow = true
      if(idEspecialidad != null){    
           api.get('/vwespecialidads/'+idEspecialidad).then(resp=>{
          this.datoEspecialidad = resp.data;
           });
      }
      this.titulo   = 'Editar Especialidad'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarEspecialidad(){
      this.$router.push('/Especialidad')
    },
// Procedimientos master
// Procedimientos detalle
    async getMedicos() {
      const resp = await api.get('/medicos')
      this.medicos = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.medicos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmedicos/nombre/'+this.nombreBusqueda).then(response=>{
          this.medicos=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.medicos.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmedicos').then(response=>{
      this.medicos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.medicos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoMedico.idEspecialidad === ''){
        swal("Error!", "El elemento idEspecialidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.tipo === ''){
        swal("Error!", "El elemento tipo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarMedico(){
      if(this.validarForm() === 1){
        try {
          this.datoMedico.idEspecialidad = this.datoEspecialidad.idEspecialidad;
          await api.post('/medicos', this.datoMedico)
          this.getMedicos();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Medico creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medicos', this.datoMedico)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Medico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoMedico={}
      this.titulo   = 'Crear Especialidad'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idMedico){
      this.modalWindow = true
      if(idMedico != null){    
           api.get('/vwmedicos/'+idMedico).then(resp=>{
          this.datoMedico = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Especialidad'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idMedico){
      this.modalWindow = true
      if(idMedico != null){
        this.$router.push('/medicomd/'+idMedico)
      }
    },
    async deleteMedico (idMedico) {
      try{
        await api.delete('/medicos/'+idMedico)
          this.getMedicos()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataMedicoLOVdet(data) {
      this.datoMedico.idMedico = data.idMedico;
      this.datoMedico.medico = data.nombre;
    },
//    Lista de Valores
    GetDataPersonaLOVdet(data) {
      this.datoMedico.idPersona = data.idPersona;
      this.datoMedico.persona = data.nombre;
    },
// Listas de valores details
  },
}
</script>
